<template>
  <base-container ref="container" :isLoading="loading">
    <ArtisanGrid ref="dept" metaKey="JyDeptInfo" :leftOption="leftOption" @selectJyDept="selectJyDept" isTree
                 defaultExpandAll>
      <template #isValid="{ row }">
        <el-switch v-model="row.isValid" active-color="#13ce66" @change="change(row)"></el-switch>
      </template>
      <template #sortNo="{ row }">
        <el-input-number style="width: 100%" v-model="row.sortNo" :controls="false" :min="0" size="mini"
                         @change="change(row)"></el-input-number>
      </template>
    </ArtisanGrid>

    <artisan-dialog ref="dialog" title="选择检查科室" :visible.sync="dialog.isShow" :isLoading="dialog.loading" height="90%"
                    width="80%">
      <el-main ref="main" style="
          padding: 0 10px;
          height: 100%;
          display: flex;
          flex-direction: column;
        ">
        <el-card>
          <artisan-group class="margin-v7" title="检索条件">
            <template #header>
              <el-row type="flex" justify="space-between" align="middle">
                <span>检索条件</span>
              </el-row>
            </template>
            <el-form ref="gridSearchForm" size="mini" :model="formData" @keyup.enter.native="search" class="grid-search">
              <el-row type="flex">
                <div style="flex: 1">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label-width="110px" prop="id" label="科室编码">
                        <el-input placeholder="请输入科室编码" size="mini" v-model="formData.code" clearable>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label-width="110px" prop="code" label="科室名称">
                        <el-input placeholder="请输入科室名称" size="mini" v-model="formData.name" clearable>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div style="margin-left: 10px">
                  <el-button size="mini" type="primary" @click="search" icon="el-icon-search" class="margin-h5">
                    查询
                  </el-button>
                  <el-button class="margin-h5" size="mini" @click="reset" icon="el-icon-refresh-left">
                    重置
                  </el-button>
                </div>
              </el-row>
            </el-form>

          </artisan-group>
        </el-card>
        <div style="margin: 7px 0">
        </div>
        <el-table border height="100% " ref="multipleTable" :row-key="getRowKey" :data="tableData" tooltip-effect="dark"
                  style="width: 100%;flex: 1" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="55" :reserve-selection="true">
          </el-table-column>
          <el-table-column prop="id" align="center" label="科室编码" min-width="120">
          </el-table-column>
          <el-table-column prop="name" align="center" label="科室名称" min-width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="hosId" align="center" label="所属院区" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ getHosName(row.hosId) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <template #footer>
        <el-button type="primary" size="mini" @click="saveJyDept">
          确认保存
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
  import { editDept, all, saveDept } from "@/api/jy/dept";
  import { loadEnums } from "@/api/sys/dicType";
  import { list } from "@/api/basis/dept";
  export default {
    data() {
      return {
        loading: false,
        dialog: {
          isShow: false,
          loading: false,
        },
        formData: {
          code: "",
          name: "",
        },
        multipleSelection: [],
        tableData: [],
        leftOption: {
          width: "20%",
          title: "院区",
          treeKey: "BasisHospitalInfo",
          searchField: "hosId",
        },
        list: [],
        jyDepts: [],
        hos: [],
      };
    },
    created() {
      loadEnums("BasisHospitalInfo").then((res) => {
        this.hos = res.data.data.BasisHospitalInfo;
      });
    },
    methods: {
      getHosName(id) {
        if (id) {
          return this.hos.find((h) => h.value == id).label
        } else {
          return ""
        }
      },
      change(row) {
        editDept(row).then((res) => { });
      },
      selectJyDept() {
        this.dialog.isShow = true;
        this.dialog.loading = true;
        all().then((res) => {
          this.jyDepts = res.data.data
          list().then((res) => {
            this.list = res.data.data
            this.tableData = this.list
            this.dialog.loading = false;
            if (this.jyDepts) {
              if (this.tableData) {
                this.$nextTick(() => {
                  this.tableData.forEach(item => {
                    this.$refs.multipleTable.toggleRowSelection(item, false);
                    this.jyDepts.forEach((d) => {
                      if (item.id == d.id) {
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                      }
                    })
                  })
                })
              }
            }
          })
        })

      },
      getRowKey(row) {
        return row.id;
      },
      search() {
        if (this.formData.id && this.formData.name) {
          this.tableData = this.list.filter(
            (r) =>
              r.id.indexOf(this.formData.id) >= 0 &&
              r.name.indexOf(this.formData.name) >= 0
          );
        } else if (this.formData.id) {
          this.tableData = this.list.filter(
            (r) => r.id.indexOf(this.formData.id) >= 0
          );
        } else if (this.formData.name) {
          this.tableData = this.list.filter(
            (r) => r.name.indexOf(this.formData.name) >= 0
          );
        }else{
          this.tableData = this.list;
        }
      },
      reset() {
        this.formData = {
          code: "",
          name: "",
        }
        this.tableData = this.list
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      saveJyDept() {
        this.$refs.dialog
          .confirm({ msg: "确认保存所选科室?" })
          .then(() => {
            return saveDept(this.multipleSelection);
          })
          .then((res) => {
            this.dialog.loading = false;
            this.dialog.isShow = false;
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            this.$refs.dept.reload();
          })
          .catch(() => {
            this.dialog.loading = false;
          });
      },

    },
  };
</script>

<style></style>
